import { render, staticRenderFns } from "./RenameRoomModal.vue?vue&type=template&id=68b64db7&scoped=true&"
import script from "./RenameRoomModal.vue?vue&type=script&lang=js&"
export * from "./RenameRoomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b64db7",
  null
  
)

export default component.exports